import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

const prefix = 'facial-registration.camera-error';

const CameraErrorAlert = ({ onTryAgain, onClose }) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.Container>
      <S.Content>
        <S.VideoCamOffIcon />
        <S.TextWrapper>
          <S.Title>{t(`${prefix}.title`)}</S.Title>
          <S.Description>{t(`${prefix}.description`)}</S.Description>
        </S.TextWrapper>
      </S.Content>
      <S.ButtonsWrapper>
        <S.Button variant="contained" onClick={onTryAgain}>
          {t(`${prefix}.try-again`)}
        </S.Button>
        <S.Button variant="text" onClick={onClose}>
          {t(`${prefix}.close`)}
        </S.Button>
      </S.ButtonsWrapper>
    </S.Container>
  );
};

CameraErrorAlert.propTypes = {
  onTryAgain: propTypes.func.isRequired,
  onClose: propTypes.func.isRequired,
};

export default CameraErrorAlert;
